import { render, staticRenderFns } from "./majorJd.vue?vue&type=template&id=73dacad0&scoped=true&"
import script from "./majorJd.vue?vue&type=script&lang=js&"
export * from "./majorJd.vue?vue&type=script&lang=js&"
import style0 from "./majorJd.vue?vue&type=style&index=0&id=73dacad0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dacad0",
  null
  
)

export default component.exports